import { lazy } from "react";

const ForMediaPage = lazy(() => import("./ForMediaPage"));

export { ForMediaPage };
